import Vue from 'vue'
import VueI18n, { LocaleMessages } from 'vue-i18n'
import { langDictionary } from './locales/index'

Vue.use(VueI18n)

function loadLocaleMessages (): LocaleMessages {
  const messages: LocaleMessages = {}
  Object.keys(langDictionary).forEach(key => {
    messages[key] = langDictionary[key]
  })
  return messages
}

export default new VueI18n({
  locale: 'es',
  fallbackLocale: 'es',
  messages: loadLocaleMessages()
})
